export interface Address {
    id?: any;
    /**
     * @Description : Represents the user `First Name` for his `Address` details
     */
    firstName: string;
    /**
     * @Description : Represents the user `Last Name` for his `Address` details
     */
    lastName: string;

    /**
     * @Description : Represents the user `City` for his `Address` details
     */
    city: string;

    /**
     * @Description : Represents the user `Region` for his `Address` details
     */
    region: string;

    /**
     * @Description : Represents the user `ZipCode` for his `Address` details
     */
    zipCode: string;

    /**
     * @Description : Represents the user `Country` for his  `Address` details
     */
    country: string;

    /**
     * @Description : The street line one
     */
    addressLineOne: string;

    /**
     * @Description : The street line two
     */
    addressLineTwo: string;

    /**
     * If user is public, enter email here for communication
     */
    email?: string;

    /**
     *  If user is public, enter phone here for communication
     */
    phone?: string;
}
